import React from 'react';

import moment from 'moment';

export const options = {
  columns: [
    { id: -1, name: '', label: '', sortable: false},
    { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number', expand: true, },
    { id: 2, name: 'platName', label: 'DSP Name', sortable: true, type: 'string' },
    { id: 3, name: 'platName', label: 'DSP Logo', sortable: true, type: 'string',  component: row => <img style={{border:'1px solid gray'}} src={row.logoUrl}/>},
    // { id: 4, name: 'type', label: ' Margin Type', sortable: true, type: 'string', component: (row) =>row.type == "fixedvalue" ? <span>Fixed Value</span>: '%Value' },
    // { id: 5, name: 'value', label: 'Margin Value  ', sortable: true, type: 'number'},
   
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  },
  ],
  // recActive: true,
  // status: {
  //   key: 'rec_active',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Are you sure you want to inactive this record?',
  //   inActiveConfirmationMessage: 'Are you sure you want to active this record?',
  // },
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    // sortBy: 'date',
    // sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};

export const status = [
  {}
]